export interface NewsItem {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  views: string;
  author: string;
  readTime: string;
  image: string;
  pinned?: boolean;
  tags: string[];
  content: string;
}

export const allNewsData: NewsItem[] = [
  {
    id: 'company-top20-2025',
    category: '公司新闻',
    title: '福建龙创未来入选中国互联网企业综合实力指数（2025年）成长型TOP20',
    excerpt: '2025年12月29日，中国互联网协会在北京正式发布了《中国互联网企业综合实力指数（2025年）》报告，福建龙创未来软件科技有限公司成功跻身互联网成长型企业TOP20榜单，彰显了公司在AI与数字化领域的持续创新实力与市场竞争力。',
    date: '2025-12-29',
    views: '2.1k',
    author: '龙创未来品牌中心',
    readTime: '5 分钟',
    image: 'https://public.readdy.ai/ai/img_res/7d1be683b43fa6d12b99483d0623f0fa.jpg',
    pinned: true,
    tags: ['荣誉', '公司动态', 'AI产业'],
    content: `<h2>重大荣誉：跻身成长型企业TOP20</h2>
<p>2025年12月29日，中国互联网协会在北京国家会议中心正式发布《中国互联网企业综合实力指数（2025年）》权威报告。本次评选依据企业技术创新能力、市场影响力、营收规模、用户规模及行业贡献度等多维度指标体系综合评定，共评出百强企业、成长型TOP20及专项奖项。</p>
<p>福建龙创未来软件科技有限公司凭借在人工智能、工业数字化及端侧智能等核心赛道的持续深耕与创新突破，成功入选<strong>互联网成长型企业TOP20</strong>，成为福建省唯一上榜的AI领域代表性企业。</p>

<h2>评选亮点：三大维度脱颖而出</h2>
<p>在本次评选过程中，龙创未来在以下三大维度展现出突出优势：</p>
<p><strong>技术创新能力：</strong>公司自主研发的端侧大模型推理框架和工业AI视觉检测系统，连续两年获得国家级科技成果认证，核心专利数量位居福建省AI企业前三。</p>
<p><strong>市场拓展速度：</strong>2024年营收同比增长167%，客户覆盖制造业、能源、医疗健康等八大垂直行业，年内新增签约客户超过120家。</p>
<p><strong>生态建设成效：</strong>与华为、浪潮、中国电信等头部企业建立深度战略合作，形成完整的AI产业生态圈，带动上下游产业链就业超过500人。</p>

<h2>总裁致辞</h2>
<p>公司总裁在颁奖典礼致辞中表示："这份荣誉是对全体龙创未来人共同努力的最好肯定，也是我们继续前行的新起点。我们将始终坚守技术创新的初心，深耕AI与数字化的融合应用，为中国产业智能化贡献更大力量。"</p>

<h2>未来展望</h2>
<p>站在2026年的新起点，龙创未来将进一步加大在大模型基础研究、边缘计算芯片及工业AI平台三大方向的研发投入，计划在未来三年内将核心技术团队扩充至500人，并在北京、深圳、成都三地布局研发中心，构建覆盖全国的AI技术服务网络。</p>
<p>公司同时宣布启动"龙创AI百城计划"，将联合地方政府与产业园区，为100个城市的中小企业提供普惠化AI数字转型服务，助力"数字中国"战略落地。</p>`,
  },
  {
    id: 'ai-llm-industry-2025',
    category: '行业动态',
    title: 'AI大模型在工业领域的应用趋势与挑战',
    excerpt: '随着大语言模型技术的快速发展，工业领域正迎来智能化转型的新机遇。本文深入分析了AI大模型在制造业的应用场景，探讨如何通过智能化手段提升生产效率与质量管控水平。',
    date: '2025-01-12',
    views: '856',
    author: '技术研究院',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20engineer%20working%20with%20industrial%20AI%20technology%20and%20large%20language%20model%20interface%20in%20modern%20manufacturing%20facility%2C%20Asian%20male%20technician%20analyzing%20data%20visualization%20on%20digital%20screens%20with%20smart%20factory%20equipment%20and%20robotic%20systems%20in%20background%2C%20professional%20lighting%20with%20clean%20technology%20environment%20representing%20industry%20transformation%20trends&width=800&height=600&seq=news2cn&orientation=landscape',
    tags: ['AI大模型', '工业智能', '数字化转型'],
    content: `<h2>大模型进入工业"深水区"</h2>
<p>2025年被业界普遍认定为AI大模型在工业领域规模化落地的关键之年。随着GPT-4o、Claude 3.5、Kimi等通用大模型能力的快速演进，以及面向工业场景的垂直模型不断涌现，制造业的智能化转型正从"试点实验"迈向"规模部署"。</p>
<p>根据工业和信息化部最新数据，截至2025年Q3，全国规模以上制造企业中已有超过38%启动了AI大模型相关的数字化改造项目，较2024年同期增长超过两倍。</p>

<h2>五大核心应用场景</h2>
<p><strong>1. 设备预测性维护</strong></p>
<p>传统设备维护依赖定期巡检，响应滞后且成本高昂。大模型结合传感器数据流，能实现设备健康状态的实时分析与故障预测，某汽车零部件企业应用后非计划停机率下降了64%。</p>
<p><strong>2. 质量视觉检测</strong></p>
<p>工业视觉大模型（如龙创未来自研的 LongVision-Pro）在PCB缺陷检测、焊点质量判定等场景中展现出超越人工的检测精度，误检率降至0.3%以下。</p>
<p><strong>3. 工艺参数优化</strong></p>
<p>大模型通过海量历史生产数据的迁移学习，能够自动推荐最优工艺参数组合，某半导体封装企业的良品率提升了2.7个百分点。</p>
<p><strong>4. 供应链智能调度</strong></p>
<p>多模态大模型集成采购、库存、物流数据，实现跨供应商的动态调度与风险预警，帮助企业在原材料波动时期减少库存积压约40%。</p>
<p><strong>5. 知识库与工程师助手</strong></p>
<p>将企业设备手册、工艺规范、故障案例等知识体系化，构建"AI工程师助手"，新员工学习周期由平均6个月缩短至1.5个月。</p>

<h2>三大核心挑战</h2>
<p>尽管前景广阔，大模型在工业落地仍面临显著挑战：</p>
<p><strong>数据安全与隐私：</strong>工业数据涉及核心工艺机密，上云训练存在较大风险。企业普遍倾向于"端侧部署+本地推理"的私有化方案，但这对模型压缩与推理性能提出了更高要求。</p>
<p><strong>实时性要求：</strong>工业控制场景对响应延迟极为敏感，通用大模型的推理速度难以满足毫秒级响应需求，轻量化、蒸馏化的行业模型成为关键方向。</p>
<p><strong>人才缺口：</strong>既懂工业机理又懂AI模型调优的复合型人才稀缺，制约了项目实施质量与速度。</p>

<h2>龙创未来的实践路径</h2>
<p>龙创未来已在此方向形成完整解决方案体系，核心策略是"大模型能力+行业Know-how+端侧部署"三位一体，通过自研的 LongAI-Edge 推理引擎，将千亿参数模型压缩至可在边缘设备稳定运行，为客户实现数据不出厂的同时享受大模型智能红利。</p>`,
  },
  {
    id: 'edge-ai-chip-practice',
    category: '技术分享',
    title: '端侧AI芯片设计：从架构到量产的实践经验',
    excerpt: '本文分享了我们在端侧AI芯片开发过程中的技术选型、架构设计、算法优化以及量产落地的完整经验，为行业同仁提供可借鉴的实践参考。',
    date: '2025-01-10',
    views: '723',
    author: '芯片研发部',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20semiconductor%20engineer%20examining%20AI%20chip%20design%20blueprint%20with%20technical%20architecture%20diagrams%20in%20modern%20laboratory%2C%20Asian%20female%20researcher%20in%20white%20lab%20coat%20analyzing%20microchip%20wafer%20and%20circuit%20boards%20with%20precision%20equipment%2C%20professional%20clean%20technology%20background%20with%20blue%20lighting%20representing%20edge%20computing%20innovation%20and%20chip%20manufacturing%20process&width=800&height=600&seq=news3cn&orientation=landscape',
    tags: ['芯片设计', '端侧AI', '量产经验'],
    content: `<h2>为什么要做端侧AI芯片</h2>
<p>随着物联网设备的爆发式增长和数据隐私法规的日益严格，将AI推理能力部署到终端设备已成为不可逆转的行业趋势。相比云端推理，端侧AI具备三大核心优势：超低延迟（<10ms）、数据本地处理（隐私安全）、断网可用（可靠性高）。</p>
<p>龙创未来的端侧AI芯片研发项目启动于2023年初，历经两年多的设计迭代与工程化攻关，于2025年Q2完成首批量产，累计出货量突破50万颗。</p>

<h2>架构设计：三大核心决策</h2>
<p><strong>决策一：NPU架构选型</strong></p>
<p>我们最终选择了基于数据流的脉动阵列（Systolic Array）架构，而非传统GPU式的SIMD并行架构。核心理由是脉动阵列在矩阵乘法密集型的Transformer推理任务中能效比更优，实测INT8推理能效达到18 TOPS/W，超越同级别竞品35%。</p>
<p><strong>决策二：存储体系设计</strong></p>
<p>针对Transformer模型的大KV Cache需求，我们设计了分层缓存体系：片上SRAM（4MB）+片外LPDDR5（最高16GB），并自研了Smart Prefetch引擎，将内存访问延迟降低了约60%。</p>
<p><strong>决策三：混合精度计算</strong></p>
<p>支持FP16/INT8/INT4三种精度混合推理，通过自适应量化感知训练，在INT4精度下将7B参数模型的性能损失控制在1.2%以内，大幅降低了内存带宽需求。</p>

<h2>算法优化：五项关键技术</h2>
<p>硬件设计之外，配套的算法优化同样至关重要：</p>
<ul>
<li><strong>模型蒸馏：</strong>将百亿参数教师模型的知识迁移至十亿参数学生模型，核心任务性能保留率达92%</li>
<li><strong>结构化剪枝：</strong>针对特定硬件架构设计对齐剪枝策略，实际加速比达2.3x</li>
<li><strong>算子融合：</strong>将Attention中的多个小算子融合为单一大算子，减少内存搬运次数约40%</li>
<li><strong>动态批处理：</strong>根据负载自动调整批大小，提升整体吞吐量25%</li>
<li><strong>投机解码：</strong>引入草稿模型加速自回归生成，端到端token生成速度提升1.8x</li>
</ul>

<h2>量产踩坑：那些差点让我们崩溃的问题</h2>
<p><strong>热设计问题：</strong>首批试产芯片在高负载场景下出现局部过热，经过热仿真分析发现是NPU核心区域功耗密度过高。我们通过重新布局热路径和增加热传导通孔，最终将最高结温降低了18°C。</p>
<p><strong>良品率爬坡：</strong>初期良品率仅为71%，低于目标值15个百分点。通过与晶圆厂联合排查，定位到了特定金属层的填充率问题，调整DRC规则后良品率提升至89%。</p>
<p><strong>软硬件协同调试：</strong>驱动栈与芯片硬件接口的调试是最耗时的环节，历时约4个月。建议同类项目务必在RTL仿真阶段就搭建软件原型，而非等FPGA验证完成后才启动。</p>

<h2>结语</h2>
<p>端侧AI芯片是一个高门槛、长周期的赛道，但也是AI普惠化不可绕过的基础设施。希望本文的实践分享能为正在这条路上探索的同行提供一些有价值的参考。欢迎与我们深度交流。</p>`,
  },
  {
    id: 'digital-economy-60trillion',
    category: '行业动态',
    title: '2025年中国数字经济规模突破60万亿，AI产业成核心驱动力',
    excerpt: '国家数据局最新报告显示，2025年中国数字经济总规模突破60万亿元，同比增长12.3%。人工智能产业作为核心驱动力，带动软件、云计算、大数据等相关产业链协同发展，形成新质生产力的重要支撑。',
    date: '2025-02-18',
    views: '1.4k',
    author: '行业分析团队',
    readTime: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=China%20digital%20economy%20growth%20chart%20and%20data%20visualization%20in%20modern%20business%20conference%20room%2C%20Chinese%20government%20officials%20and%20tech%20executives%20reviewing%20economic%20report%20with%20large%20LED%20display%20showing%20rising%20statistics%20and%20AI%20industry%20growth%20figures%2C%20professional%20corporate%20environment%20with%20clean%20white%20and%20teal%20color%20scheme%20representing%20digital%20transformation%20milestone&width=800&height=600&seq=news4cn&orientation=landscape',
    tags: ['数字经济', 'AI产业', '政策解读'],
    content: `<h2>60万亿：一个历史性里程碑</h2>
<p>2025年3月，国家数据局发布《中国数字经济发展报告（2025年）》，正式确认中国数字经济总规模在2025年突破60万亿元大关，达到61.8万亿元，同比增长12.3%，占GDP比重提升至约44%，稳居全球第二大数字经济体。</p>
<p>这一成就背后，人工智能产业的高速增长是最重要的引擎之一。2025年AI核心产业规模超过6500亿元，同比增长约35%，带动相关产业规模超过4.5万亿元。</p>

<h2>AI产业三大增长极</h2>
<p><strong>基础层：算力基础设施投资创历史新高</strong></p>
<p>2025年全国新增AI算力中心超过200个，总算力规模达到3000 EFLOPS，国产AI芯片自给率从2023年的15%提升至38%。国家"东数西算"工程全面完工，形成京津冀、长三角、粤港澳、成渝、西部五大算力枢纽节点。</p>
<p><strong>中间层：大模型生态百花齐放</strong></p>
<p>截至2025年底，国内备案大模型数量超过1200个，其中参数规模超过百亿的基础大模型达到87个。在医疗、法律、金融、教育等垂直领域的专用模型表现已接近甚至超越国际头部产品。</p>
<p><strong>应用层：千行百业智能化加速</strong></p>
<p>工业、零售、医疗、政务四大领域AI应用渗透率均突破30%。智能制造领域尤为突出，AI辅助质量检测、智能排产、能耗优化等应用已在规模以上工业企业中广泛落地，平均降本提效幅度超过20%。</p>

<h2>政策面：新一轮支持政策密集出台</h2>
<p>2025年国家层面围绕AI产业共出台重要政策文件超过30份，核心举措包括：</p>
<p>• 设立1000亿元国家AI产业发展引导基金</p>
<p>• 推出AI企业研发费用200%加计扣除政策</p>
<p>• 建立国家层面的AI伦理与安全评估认证体系</p>
<p>• 推动AI在政务服务、城市治理领域的规模化应用</p>

<h2>对中小AI企业的机遇研判</h2>
<p>市场规模的快速扩张为龙创未来等成长型AI企业提供了难得的历史窗口期。我们判断，未来2-3年垂直行业的AI解决方案市场将呈现"群雄逐鹿"的态势，具备行业深度Know-how和工程化交付能力的企业将率先完成市场卡位。</p>`,
  },
  {
    id: 'rag-tech-deep-dive',
    category: '技术分享',
    title: '大模型RAG技术深度解析：提升企业知识库检索精度的实战方案',
    excerpt: '检索增强生成（RAG）技术已成为企业级AI落地的关键路径。本文从向量数据库选型、分块策略优化、混合检索架构等维度，系统梳理了RAG在实际业务场景中的工程化实践，帮助企业构建高精度、低幻觉的智能问答系统。',
    date: '2025-03-05',
    views: '1.1k',
    author: 'AI工程团队',
    readTime: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20software%20engineer%20analyzing%20RAG%20retrieval%20augmented%20generation%20architecture%20diagram%20on%20multiple%20monitors%20in%20modern%20tech%20office%2C%20Asian%20developer%20with%20code%20editor%20showing%20vector%20database%20and%20knowledge%20graph%20visualization%2C%20clean%20minimalist%20workspace%20with%20warm%20ambient%20lighting%20representing%20advanced%20AI%20engineering%20and%20enterprise%20knowledge%20management%20system&width=800&height=600&seq=news5cn&orientation=landscape',
    tags: ['RAG', '大模型', '知识库', '工程实践'],
    content: `<h2>为什么RAG是企业AI的"必经之路"</h2>
<p>通用大模型存在三个制约企业级应用的天然缺陷：知识截止日期、领域知识缺失、以及难以消除的"幻觉"问题。RAG（Retrieval-Augmented Generation，检索增强生成）通过将外部知识库的实时检索结果注入提示词，从根本上解决了上述问题，成为构建企业智能问答、文档助手、合规审查等应用的首选架构。</p>
<p>龙创未来在为超过60家企业客户部署知识库AI系统的过程中，积累了大量宝贵的工程经验，本文系统整理如下。</p>

<h2>向量数据库选型指南</h2>
<p>向量数据库是RAG架构的核心组件，直接影响检索性能与系统稳定性。我们对主流方案进行了全面评测：</p>
<p><strong>Milvus（推荐）：</strong>开源，支持多种索引类型（HNSW/IVF/DiskANN），千万级向量QPS可达2000+，是大规模企业部署的首选。但运维复杂度较高，需要专业团队维护。</p>
<p><strong>Qdrant：</strong>Rust编写，内存效率极高，适合中小规模部署。REST和gRPC接口完善，上手门槛低。</p>
<p><strong>PGVector：</strong>PostgreSQL插件，适合已有PostgreSQL技术栈的团队，快速验证阶段的理想选择，但性能天花板明显。</p>
<p><strong>我们的选择策略：</strong>POC阶段用PGVector，生产环境10万以下向量用Qdrant，超过100万向量上Milvus。</p>

<h2>分块策略：影响RAG效果的关键变量</h2>
<p>文档分块质量直接决定检索结果的相关性，这是被众多工程师低估的核心环节：</p>
<p><strong>固定大小分块：</strong>实现简单但效果差，跨句截断导致语义割裂，不推荐用于生产环境。</p>
<p><strong>语义分块：</strong>基于句子向量相似度的动态边界识别，效果显著优于固定分块，是我们的默认选择。</p>
<p><strong>文档结构感知分块：</strong>针对PDF、Word等格式文件，识别标题、段落、表格等结构信息，按逻辑单元分块。实测在合同、技术手册等场景中检索精度提升约25%。</p>
<p><strong>父子分块策略：</strong>小块用于精确检索（128 tokens），大块（512 tokens）用于上下文注入，在保证精度的同时确保答案完整性。</p>

<h2>混合检索架构：1+1>2</h2>
<p>单纯的向量检索在处理专有名词、产品编号、法规条文编号等精确匹配需求时表现不佳。我们采用"向量检索+BM25关键词检索"的混合架构，通过倒数排名融合（RRF）算法合并结果：</p>
<p>• 向量检索权重：0.6（负责语义理解）</p>
<p>• BM25检索权重：0.4（负责精确匹配）</p>
<p>在企业知识库场景的端到端测评中，混合检索相比纯向量检索，Recall@5提升约18%，这是一个非常显著的改善。</p>

<h2>Reranker：最后一公里的精度保障</h2>
<p>检索Top-K结果后，加入Cross-Encoder Reranker对候选结果进行精排，能有效过滤相关性较低的干扰项。我们推荐使用 bge-reranker-v2-m3 模型，在中文场景下精排效果优于同类产品，且4GB显存即可部署。</p>
<p>加入Reranker后，我们客户的知识库系统平均答案准确率从78%提升至91%，幻觉率从12%下降至3%以下。</p>

<h2>结语</h2>
<p>RAG工程是一个持续迭代的过程，没有放之四海皆准的最优配置。建议团队建立完善的评测体系，以数据驱动的方式持续优化各个环节。欢迎与我们团队深入交流。</p>`,
  },
  {
    id: 'industrial-internet-reshape',
    category: '行业动态',
    title: '工业互联网平台市场格局重塑，垂直行业AI融合加速',
    excerpt: '2025年工业互联网平台市场进入深度整合阶段，头部平台加速向垂直行业延伸，AI与工业数据的深度融合催生出设备预测性维护、质量视觉检测、供应链智能调度等一批高价值应用，推动制造业数字化转型进入新阶段。',
    date: '2025-03-20',
    views: '978',
    author: '行业分析团队',
    readTime: '7 分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20industrial%20internet%20platform%20visualization%20with%20smart%20factory%20floor%20showing%20connected%20machines%20and%20IoT%20sensors%2C%20Asian%20engineers%20monitoring%20production%20line%20data%20on%20large%20control%20room%20screens%20with%20real-time%20analytics%20dashboard%2C%20modern%20industrial%20facility%20with%20clean%20professional%20atmosphere%20representing%20manufacturing%20digital%20transformation%20and%20AI%20integration&width=800&height=600&seq=news6cn&orientation=landscape',
    tags: ['工业互联网', '智能制造', '平台生态'],
    content: `<h2>市场格局：从群雄并立到梯队分化</h2>
<p>经过五年高速发展，中国工业互联网平台市场正从"百花齐放"进入"强者恒强"的深度整合阶段。2025年，全国工业互联网平台数量已超过340个，但头部效应加速显现：TOP10平台汇聚了超过70%的工业设备连接量和约65%的行业解决方案资源。</p>
<p>市场规模方面，2025年工业互联网平台相关市场规模达到1680亿元，同比增长28%，预计2027年将突破3000亿元。</p>

<h2>AI融合：平台的"第二增长曲线"</h2>
<p>单纯的设备连接与数据采集已不再是平台核心竞争力，以AI能力为核心的"智能化服务"正成为头部平台的主战场：</p>
<p><strong>预测性维护：</strong>基于设备运行数据训练的故障预测模型，已在钢铁、化工、电力行业实现规模化部署。某头部平台公开数据显示，其预测性维护服务使客户设备非计划停机时间平均降低55%。</p>
<p><strong>质量视觉检测：</strong>AI视觉检测正在替代传统人工抽检，覆盖焊接质量、表面缺陷、装配偏差等场景。龙创未来的 LongVision 系列产品已在汽车、3C电子、精密机械等领域的23条生产线上投入使用，整体检测效率提升约4倍。</p>
<p><strong>能碳管理：</strong>随着"双碳"目标推进，AI驱动的能耗优化和碳排放核算成为高需求场景，部分平台已将此作为差异化核心卖点。</p>

<h2>垂直化战略：通用平台的突围路径</h2>
<p>面对垂直型竞争对手的强势崛起，大型通用平台纷纷加速垂直行业战略布局：</p>
<p>航天云网深化航空航天供应链协同；卡奥斯聚焦家电与建材行业；徐工汉云主攻工程机械全生命周期管理；树根互联在轨道交通和能源领域重点发力。</p>
<p>这种"通用底座+垂直行业应用"的双层架构，既保留了平台的规模优势，又实现了行业场景的深度适配，正在成为主流范式。</p>

<h2>龙创未来的生态定位</h2>
<p>在这一市场格局中，龙创未来选择了"平台赋能者"的差异化定位，为工业互联网平台提供AI能力模块（视觉检测、自然语言交互、预测分析）的嵌入式集成，避免与平台型企业的正面竞争，同时充分借助平台的行业资源触达更多终端客户。目前已与国内5大工业互联网平台建立正式合作关系。</p>`,
  },
];
